import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { translate, convertToUppercase, getPreAllocationArea, getDefaultPrint, isNullOrEmpty, showMessageToastCustom, closeCollapsible } from '../../../../utils/util';
import { Input, BackButton, Button, Select, ScannerCode, SelectResource, Title, Collapsible } from '../../../../components/UI/ComponentsUI';
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';
import ChangeLocationService from '../../../../services/ChangeLocationService';
import { ENUMS, VISIONS } from '../../../../utils/constants';
import { getVision } from '../../../../services/auth';
import PhysicalConfirmationService from '../../../../services/PhysicalConfirmationService';

const MassiveChangeLocation = (props) => {
    let physicalConfirmation = props.location?.state?.physicalConfirmation;
    var vision = getVision();
    const [selectedItems, setSelectedItems] = useState([]);
    const [messages, setMessages] = useState([]);
    const [selectAll, setSelectAll] = useState(false)
    const [items, setItems] = useState([]);
    const [changeLocation, setChangeLocation] = useState({
        location: getPreAllocationArea(vision),
        print: getDefaultPrint(vision),
        resourceId: props.user.resource || '',
        mdr: undefined,
        amountTag: undefined,
        cimQuantity: 0
    });
    const [filter, setFilter] = useState(
        {
            mvmNumber: undefined,
            journey: undefined
        });

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const onChangeLocation = (event) => {
        onValueChange(event, changeLocation, setChangeLocation);
    };

    const onClickSearch = () => {
        if (validateInputsRequired('filterForm')) {
            setItems([])
            setSelectedItems([])
            setMessages([])
            props.getCims(filter, (response) => {
                if (response.length > 0) {
                    let cims = response.filter(x => !isNullOrEmpty(x.cim))
                    setItems(cims)
                    closeCollapsible("collapsibleMassiveLocation")
                } else {
                    showMessageToastCustom(translate('general:warning'), translate('general:no-registry'), 3000, 'mdi mdi-alert-circle-outline red-text');
                }
            })
        }
    }

    const scannerLocation = (value) => {
        if (!isNullOrEmpty(value)) {
            const changeLocationObj = {}
            Object.assign(changeLocationObj, changeLocation);
            changeLocationObj.location = value;
            setChangeLocation(changeLocationObj);
        }
    };

    const onCheckItem = (value) => {
        const array = [];
        Object.assign(array, selectedItems);
        let index = selectedItems.findIndex((e) => e === value.cim);
        if (index === -1) {
            array.push(value.cim)
            if (array.length === items.length) {
                setSelectAll(true)
            }
        } else {
            setSelectAll(false)
            array.splice(index, 1);
        }
        setSelectedItems(array);
    }

    const setResource = () => {
        if (changeLocation.print === ENUMS.ePrintTypes.Click.value && !isNullOrEmpty(props.user?.resourceObj?.clickResourceName)) {
            return props.user?.resourceObj?.clickResourceName;
        }

        return props.user?.resourceObj?.name;
      }

    const onClickSend = () => {
        if (validateInputsRequired('changeLocationForm')) {
            let dto = {
                ...changeLocation,
                resource: setResource(),
                printer: props.user?.printer,
                barCodes: selectedItems
            }

            props.sendMassiveChangeLocation(dto, (messages) => {
                setMessages(messages)
            })
        }
    }

    const convertToUpper = (evt) => {
        convertToUppercase(evt)
        onChangeLocation(evt);
    }

    const onClickSelectAll = () => {
        if (selectAll) {
            setSelectAll(false)
            setSelectedItems([])
        } else {
            var allCims = items.map(x => x.cim)
            setSelectAll(true)
            setSelectedItems(allCims)
        }
    }

    return (
        <div>
            <BackButton {...props} />
            <Title icon="mdi mdi-vector-polyline-plus" label={translate('massive-change-location', 'change-location')} />
            <div className="container-fluid">
                <div className="container" style={{ marginTop: '0px' }}>
                    <Collapsible
                        id="collapsibleMassiveLocation"
                        header={translate('line-picking:linepicking.filter')}
                        body={
                            <>
                                <form id="filterForm" >
                                    <div className="row">
                                        <div className="input-field no-padding col s6">
                                            <Input
                                                id="mvmNumber"
                                                name='mvmNumber'
                                                required={isNullOrEmpty(filter?.journey)}
                                                label={translate('mvm', 'physical-confirmation')}
                                                type="text"
                                                defaultValue={filter?.mvmNumber || ''}
                                                onChange={onChange}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s5">
                                            <Input
                                                id="journey"
                                                name='journey'
                                                label={translate('journey', 'physical-confirmation')}
                                                type="text"
                                                defaultValue={filter?.journey || ''}
                                                onChange={onChange}
                                                required={isNullOrEmpty(filter?.mvmNumber)}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s12">
                                            <Input
                                                id="partnumbercode"
                                                name='partnumbercode'
                                                label={translate('part-number', 'physical-confirmation')}
                                                type="text"
                                                defaultValue={filter?.partnumbercode || ''}
                                                onChange={onChange}
                                            />
                                        </div>
                                    </div>
                                </form>
                                <div className="row" style={{ paddingTop: '5px' }}>
                                    <Button
                                        full="true"
                                        text={translate('search', 'general')}
                                        onClick={() => onClickSearch()}
                                    />
                                </div>
                            </>
                        }
                    />
                    {items.length > 0 &&
                        <div className="card" style={{ padding: '15px' }}>
                            <Collapsible
                                id="collapsible2"
                                header={translate("cims", "change-location")}
                                body={
                                    <>
                                        {items.length > 1 &&
                                            <div onClick={() => onClickSelectAll()}>
                                                <i
                                                    style={{ cursor: 'pointer', fontSize: '1.5rem', marginRight: '10px' }}
                                                    className={`mdi mdi-checkbox-multiple${selectAll ? '-marked green' : '-blank-outline grey'}-text`}
                                                />
                                                <b style={{ color: `${selectAll ? 'green' : 'grey'}` }} >{translate('SelectAll', 'general')}</b>
                                            </div>
                                        }
                                        {items?.map((item) => (
                                            <Input
                                                key={item.cim}
                                                type="checkbox"
                                                label={`${translate('cim', 'change-location')}: ${item.cim} - ${translate('part-number', 'physical-confirmation')}: ${item.partNumberCode}`}
                                                onChange={() => onCheckItem(item)}
                                                id="select"
                                                name="select"
                                                checked={selectedItems.some(e => e === item.cim)}
                                            />
                                        ))}
                                    </>
                                }
                            />
                            <form id="changeLocationForm">
                                <div className="input-field col s12">
                                    <Select
                                        required
                                        id="print"
                                        name="print"
                                        display="name"
                                        label={translate('print-type', 'physical-confirmation')}
                                        placeHolder={translate('choose-one-option', 'general')}
                                        data={[
                                            { id: ENUMS.ePrintTypes.Logistics.value, text: translate(ENUMS.ePrintTypes.Logistics.text, 'physical-confirmation') },
                                            { id: ENUMS.ePrintTypes.Click.value, text: translate(ENUMS.ePrintTypes.Click.text, 'physical-confirmation') },
                                            { id: ENUMS.ePrintTypes.NotPrint.value, text: translate(ENUMS.ePrintTypes.NotPrint.text, 'physical-confirmation') },
                                        ]}
                                        change={(e) => {
                                            props.setPrintSelect(e.target.value);
                                            onChangeLocation(e);
                                        }}
                                        defaultValue={changeLocation.print}
                                    />
                                </div>
                                {!physicalConfirmation &&
                                    <div className="input-field col s12">
                                        <SelectResource
                                            required
                                            id="resourceId"
                                            name="resourceId"
                                            loadConfigLaser={vision === VISIONS.Jeep}
                                            value={changeLocation.resourceId}
                                            onChange={onChangeLocation}
                                        />
                                    </div>
                                }
                                <div className="input-field no-padding col s3">
                                    <Input
                                        label="MDR"
                                        id="mdr"
                                        name="mdr"
                                        type="text"
                                        onChange={(e) => {
                                            e.target.value = e.target.value.replace(/\s/g, '');
                                            convertToUpper(e)
                                        }}
                                        value={changeLocation.mdr}
                                    />
                                </div>
                                <div className="input-field col s6">
                                    <Input
                                        id="location"
                                        name="location"
                                        label={translate('location', 'change-location')}
                                        type="text"
                                        onChange={onChangeLocation}
                                        value={changeLocation?.location}
                                    />
                                    <ScannerCode onScanner={scannerLocation} />
                                </div>
                                <div className={`input-field no-padding col ${(vision === VISIONS.Faasa || vision === VISIONS.FaasaCKD) ? 's2' : 's3'}`}>
                                    <Input
                                        label={translate('box-quantity', 'change-location')}
                                        id="cimQuantity"
                                        name="cimQuantity"
                                        type="number"
                                        defaultValue={changeLocation?.cimQuantity}
                                        onChange={onChangeLocation}
                                    />
                                </div>
                                {(vision === VISIONS.Faasa || vision === VISIONS.FaasaCKD) &&
                                    <div className="input-field no-padding col s2">
                                        <Input
                                            label={translate('labels', 'general')}
                                            id="amountTag"
                                            name="amountTag"
                                            type="number"
                                            defaultValue={changeLocation?.amountTag}
                                            onChange={onChangeLocation}
                                        />
                                    </div>
                                }
                                <div className="row" style={{ paddingTop: '5px' }}>
                                    <Button
                                        full="true"
                                        text={translate('send', 'general')}
                                        onClick={() => onClickSend()}
                                    />
                                </div>
                                {messages.length > 0 &&
                                    <div id="messages" style={{ display: 'flex', flexDirection: 'column', padding: '15px 0px' }}>
                                        {messages.map((item) => (
                                            <span className={item.success ? "success-color" : "fourth-text-color"} key={item}> • {item.description} </span>
                                        ))}
                                    </div>
                                }
                            </form>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        sheds: state.configReducer.sheds,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getCims: (filter, callback) => {
            dispatch(ChangeLocationService.getCims(filter, callback));
        },
        setPrintSelect: (printSelect) => {
            dispatch(PhysicalConfirmationService.setPrintSelect(printSelect));
        },
        sendMassiveChangeLocation: (location, callback) => {
            dispatch(ChangeLocationService.massiveChangeLocation(location, callback));
        },
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(MassiveChangeLocation)));
